module.exports = __webpack_public_path__ + "img/happytable_info3.2dc77ac0.jpg";